<template>
    <div>
        <h3 class="text-lg font-semibold">
            {{ translations.deleteMyAccount || 'Delete my account' }}
        </h3>
        <p class="text-sm opacity-60">
            {{ translations.deleteMyAccountText || 'After the account has been deleted, you will have the option to recover it within 14 days.' }}
        </p>
    </div>
    <div>
        <modal
            :title="translations.areYouSure || 'Are you sure?'"
            :cancel_btn_title="translations.cancel || 'Cancel'"
            size="small"
        >
            <template #toggle>
                <btn type="light">{{ translations.delete || 'Delete' }}</btn>
            </template>
            <template #body>
                <div class="space-y-6">
                    <div class="text-sm text-gray-500">
                        {{ translations.deleteConfirmationText || 'Do you really want to delete your account?' }}
                    </div>
                    <div class="grid gap-x-6 gap-y-4">
                        <div class="col-span-2">
                            <label v-if="translations.typeDelete" class="block text-sm mb-1.5">
                                {{ translations.typeDelete }}
                            </label>
                            <label v-else class="block text-sm mb-1.5">
                                Please type <span class="font-semibold">DELETE</span> to confirm.
                            </label>
                            <text-field v-model="confirmationText" v-on:keydown.enter="deletePartner"
                                        v-on:keydown.enter.prevent="deletePartner"
                                        :error="error"/>
                        </div>
                    </div>
                </div>
            </template>
            <template #footer>
                <btn type="primary" @click="deletePartner" :loading="loading">
                    {{  translations.delete || 'Yes, delete' }}
                </btn>
            </template>
        </modal>
    </div>
</template>
<script>
export default {
    name: "PartnerDelete",
    props: ['delete_url', 'current_status', 'translations'],
    data() {
        return {
            error: false,
            loading: false,
            confirmationText: '',
        }
    },
    methods: {
        deletePartner: function () {

            if (this.loading) {
                return;
            }

            if (this.confirmationText.toLowerCase() !== 'delete') {
                this.error = true;
                return;
            }

            this.loading = true;

            axios
                .post(this.delete_url)
                .then(response => {
                    this.confirmationText = '';
                    const status = parseInt(response.data.status || -1);
                    if (status === 1) {
                        window.location.reload();
                    }
                })
                .catch(error => {
                })
                .finally(() => this.loading = false);
        }
    }
}
</script>

<style scoped>

</style>
